export const recognizeFillablePdf = (fileName: string, searchTerm = '-form') => fileName.endsWith(searchTerm);
